import { Button, FlyoutFullScreen, Icon, Modal } from "@accessdev/arc-ui-react";
import { mediaBreakpoints } from "@accessdev/arc-ui-react/utils/js";
import { t, msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import classNames from "classnames";
import React, { useState, useRef } from "react";
import Media from "react-media";
import RecommendRetailerContent from "./RecommendRetailerContent";
import "./RecommendRetailer.scss";

const RecommendRetailer = ({ message, isBtnSecondary, storeName }) => {
  const { _ } = useLingui();
  const [isModalOpen, setModalOpen] = useState(false);
  const triggerRef = useRef(null);

  const closeModal = () => {
    setModalOpen(false);
    triggerRef.current.focus();
  };

  return (
    <div id="RecommendRetailer" className={classNames("", { checkboxContainer: false })}>
      <Button
        ref={triggerRef}
        onClick={() => setModalOpen(true)}
        displayStyle={isBtnSecondary ? "primary-outlined" : "secondary-outlined"}
        type="button"
        className={isBtnSecondary && "Recommend-store-btn"}
        icon={message && "store"}
        additionalProps={{ "aria-label": message || t`Recommend a Retailer` }}
      >
        {message || _(msg`Get Started`)}
      </Button>

      {isModalOpen && (
        <>
          <Media query={mediaBreakpoints.forTabletUp}>
            <Modal onClose={closeModal} className="RecommendRetailer-modal" defaultPadding={false}>
              <RecommendRetailerContent />
            </Modal>
          </Media>
          <Media query={mediaBreakpoints.forPhoneOnly}>
            <FlyoutFullScreen
              defaultPadding={false}
              isOpen={isModalOpen}
              onClose={closeModal}
              variant="flyout RecommendRetailer-flyout"
            >
              <Icon
                role="button"
                className="RecommendRetailer-flyout-close"
                icon="close"
                onClick={closeModal}
              />
              <RecommendRetailerContent />
            </FlyoutFullScreen>
          </Media>
        </>
      )}
    </div>
  );
};

export default RecommendRetailer;
